import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface ReadLayoutsCriteria {
    dashboardId: string;
}

class ReadLayoutsCriteriaImpl implements ReadLayoutsCriteria {
    constructor(readonly dashboardId: string) {}
}

export class ReadLayoutsCriteriaBuilder {
    private dashboardId: Option<string> = none;

    static create = (): ReadLayoutsCriteriaBuilder => new ReadLayoutsCriteriaBuilder();

    withDashboardId = (dashboardId: string): ReadLayoutsCriteriaBuilder => {
        this.dashboardId = some(dashboardId);

        return this;
    };

    build = (): ReadLayoutsCriteria => {
        if (isNone(this.dashboardId)) {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadLayoutsCriteriaImpl(this.dashboardId.value);
    };
}
